export const WOW_PRICE_CT_DT_EXPERIMENT_KEY = 'wow_price_ct_dt'

/**
 * The `wow_price_ct_dt` experiment concluded on the `test` bucket and is rolled
 * out to 100%
 */
export function getWowPricingVariant(wowPricingCtDtVariant = '') {
    return 'test'
}

export function isWowVariantEnabled(wowPricingCtDtVariant = '') {
    return true
}

export function isWowPricingEnabled(wowPricingCtDtVariant = '', _isDomestic?: boolean): boolean {
    return true
}

export const isWowTestVariant = (wowPricingCtDtVariant = '') => true

export const isWowTest1Variant = (wowPricingCtDtVariant = '') => false

export const isWowTest2Variant = (wowPricingCtDtVariant = '') => false
